import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect, useLocation } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "assets/scss/argon-dashboard-react.scss";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";

import { Provider } from "react-redux";
import { createStore } from "redux";
import rootreducer from "./reducers";
const axios = require("axios");

const store = createStore(rootreducer);

// Axios Interceptor for 401 Unauthorized
axios.interceptors.response.use(
  res => res,
  err => {
    if (err.response.status === 401) {
      localStorage.clear();
      window.location.href = '/auth/login';
    }
    throw err;
  }
);

// Private Route Component with Redirect
const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = !!localStorage.getItem("authtoken");
  const location = useLocation();

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={`/auth/login?redirectTo=${encodeURIComponent(location.pathname)}`} />
        )
      }
    />
  );
};

// Handle Redirect After Login in Auth Layout
// const AuthWrapper = (props) => {
//   const query = new URLSearchParams(props.location.search);
//   const redirectTo = query.get("redirectTo");

//   if (localStorage.getItem("authtoken") && redirectTo) {
//     return <Redirect to={redirectTo} />;
//   }

//   return <AuthLayout {...props} />;
// };
const AuthWrapper = (props) => {
  const query = new URLSearchParams(props.location.search);
  const redirectTo = query.get("redirectTo");

  if (localStorage.getItem("authtoken")) {
    return <Redirect to={redirectTo || "/admin"} />;
  }

  return <AuthLayout {...props} />;
};

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} />
      
      <Switch>
        {/* Public Routes */}
        <Route path="/auth" render={(props) => <AuthWrapper {...props} />} />
        <Route exact path="/auth/userreset" render={(props) => <AuthLayout {...props} />} />

        {/* Protected Admin Routes */}
        <PrivateRoute path="/admin" component={AdminLayout} />

        {/* Default Redirects */}
        <Redirect from="/" to="/auth/login" />
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
